import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Capacitor } from "@capacitor/core";
import { Maximize2 } from "lucide-react";
import { canShowFullScreenAlerts, openFullScreenAlertSettings } from "@/utils/incomingAlerts";

/* Android 14+ : rappel tant que l'utilisateur n'a pas autorisé les alertes plein écran. */
export default function FullScreenAlertBanner() {
  const { t } = useTranslation();
  const [allowed, setAllowed] = useState(true);

  useEffect(() => {
    if (Capacitor.getPlatform() !== "android") return undefined;
    let alive = true;
    const check = async () => { const ok = await canShowFullScreenAlerts(); if (alive) setAllowed(ok); };
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    check();
    document.addEventListener("visibilitychange", onVisible);
    return () => { alive = false; document.removeEventListener("visibilitychange", onVisible); };
  }, []);

  if (allowed) return null;
  return (
    <div className="mb-4 rounded-2xl border border-brand-red/40 bg-white p-4 flex items-start gap-3" data-testid="fullscreen-alert-banner">
      <Maximize2 className="w-5 h-5 text-brand-red shrink-0 mt-0.5" />
      <div className="text-sm flex-1 min-w-0">
        <div className="font-semibold">{t("alerts.fullScreenTitle")}</div>
        <p className="text-mute mt-0.5">{t("alerts.fullScreenText")}</p>
        <button onClick={() => openFullScreenAlertSettings()} data-testid="fullscreen-alert-settings-btn"
          className="mt-3 rounded-full bg-brand-red text-white px-4 py-2 text-sm font-semibold hover:bg-ink transition-colors">
          {t("alerts.fullScreenBtn")}
        </button>
      </div>
    </div>
  );
}
